import { Box, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "100%",
  width: "100%",
  backgroundColor: "black",
  display: "flex",
  flexFlow: "column",
  zIndex: 0,
  overflow: "hidden",
  contain: "layout size", // Prevent layout shifts

  [theme.breakpoints.down("md")]: {
    contain: "none", // Allow layout shifts
  },

  // In fullscreen mode, change layout to allow absolute positioning
  "&.fullscreen": {
    position: "relative",
  },
}));

export const Spinner = styled(CircularProgress)(() => ({
  marginTop: "10em",
  marginBottom: "10em",
  position: "absolute",
  zIndex: 1,
}));

export const PlayerContainer = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
  flex: "1 1 100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "0", // Allow container to shrink
  maxHeight: "calc(100vh - 196px)", // Prevent excessive height

  "&.fullscreen": {
    height: "100%",
    maxHeight: "none",
    minHeight: "100%",
  },

  "& #player-container": {
    position: "relative",
    paddingTop: 0,
    width: "100% !important",
    height: "auto !important",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },

  "& #player-container video": {
    width: "100% !important",
    height: "auto !important",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    position: "relative",
    top: "auto",
    left: "auto",
    transform: "none",

    [theme.breakpoints.down("md")]: {
      position: "relative",
      transform: "none",
      left: "auto",
      top: "auto",
    },
  },

  "&.fullscreen #player-container": {
    ["@media all and (orientation:landscape)"]: {
      paddingTop: "0",
    },
  },

  "&.fullscreen #player-container video": {
    width: "100% !important",

    ["@media all and (orientation:portrait)"]: {
      height: "auto !important",
      top: "50%",
      left: "0",
      transform: "translate(0, -50%)",
    },
  },
}));

export const CaptionsContainer = styled("div")(({ theme }) => ({
  flex: "1 1 auto",

  // In fullscreen mode, position captions absolutely at the bottom
  ".fullscreen &": {
    position: "absolute",
    bottom: "80px",
    left: "0",
    right: "0",
    flex: "none",
    pointerEvents: "none",

    [theme.breakpoints.down("md")]: {
      bottom: "60px",
    },
  },
}));
